var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMorning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-817.993 -303.993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.979,3.777A4.98,4.98,0,0,1,40.532,5.8h0a4.98,4.98,0,0,0,5.159,2.979h0a4.98,4.98,0,0,1,5.53,5.53h0A4.98,4.98,0,0,0,54.2,19.468h0a4.98,4.98,0,0,1,2.024,7.553h0a4.98,4.98,0,0,0,0,5.957h0A4.98,4.98,0,0,1,54.2,40.532h0a4.98,4.98,0,0,0-2.979,5.159h0a4.98,4.98,0,0,1-5.53,5.53h0A4.98,4.98,0,0,0,40.532,54.2h0a4.98,4.98,0,0,1-7.553,2.024h0a4.98,4.98,0,0,0-5.957,0h0A4.98,4.98,0,0,1,19.468,54.2h0a4.98,4.98,0,0,0-5.159-2.979h0a4.98,4.98,0,0,1-5.53-5.53h0A4.98,4.98,0,0,0,5.8,40.532h0a4.98,4.98,0,0,1-2.024-7.553h0a4.98,4.98,0,0,0,0-5.957h0A4.98,4.98,0,0,1,5.8,19.468h0a4.98,4.98,0,0,0,2.979-5.159h0a4.98,4.98,0,0,1,5.53-5.53h0A4.98,4.98,0,0,0,19.468,5.8h0a4.98,4.98,0,0,1,7.553-2.024h0a4.98,4.98,0,0,0,5.957,0Z",
    transform: "translate(817.993 303.993)",
    fill: "#ff822d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(827.993 313.993)",
    fill: "#fcd53f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorning);
export default __webpack_public_path__ + "static/media/Morning.7f19849c3e6c2fbe6f2db9ecf02c40e6.svg";
export { ForwardRef as ReactComponent };